// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Language } from "generated/mos/i18n";
import { LinkableMediaValue, LinkablePlacementValue, LinkableStringValue } from "generated/mos/linkable";
import { AudioSiteContent, CarouselItem, CarouselItemValue, EventPointOfInterest, GenericPointOfInterest, Mood, Stop, StopPointOfInterest, Tour, TourCategory, VisitorType } from "generated/mos/org/getty/audio";
import { MoodColor } from "generated/mos/org/getty/color";
import { Category, CategoryValues } from "generated/mos/org/getty/pointofinterest";
import { TranslatableLinkableStringValue, TranslatableMediaValue, TranslatableStringValue } from "generated/mos/translatable";
import { Codec, DecodeContext, FieldMask, RemoteObject, WebRPCError, decodeMessageRepeated, ensureScalar, stripTypePropertyDeep } from "generated/webrpc";

export namespace CreateCarouselItemRequest {
  export const refName = "mos.org.getty.audio_management.CreateCarouselItemRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly value: CarouselItemValue.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    value: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["value"] = CarouselItemValue.codec.encode(v.value);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateCarouselItemRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["value"] = ctx.decode(CarouselItemValue.codec, v["value"], "value");
      return out as any as Entity;
    }
  }();
}

export namespace CreateCarouselItemResponse {
  export const refName = "mos.org.getty.audio_management.CreateCarouselItemResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly carouselItem: CarouselItem.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    carouselItem: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["carouselItem"] = CarouselItem.codec.encode(v.carouselItem);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateCarouselItemResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["carouselItem"] = ctx.decode(CarouselItem.codec, v["carouselItem"], "carouselItem");
      return out as any as Entity;
    }
  }();
}

export namespace CreateEventPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_management.CreateEventPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly eventRef: { readonly typename: 'mos.org.getty.integration.Getty360Event', readonly id: string } | undefined,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    eventRef: undefined,
    moodRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateEventPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["eventRef"] = v["eventRef"];
      out["moodRef"] = v["moodRef"];
      return out as any as Entity;
    }
  }();
}

export namespace CreateEventPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_management.CreateEventPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly eventPointOfInterest: EventPointOfInterest.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    eventPointOfInterest: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["eventPointOfInterest"] = EventPointOfInterest.codec.encode(v.eventPointOfInterest);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateEventPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["eventPointOfInterest"] = ctx.decode(EventPointOfInterest.codec, v["eventPointOfInterest"], "eventPointOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace CreateGenericPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_management.CreateGenericPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
    readonly title: TranslatableStringValue.Entity | undefined,
    readonly category: Category,
  }
  export const defaults: Entity = {
    type: refName,
    moodRef: undefined,
    title: undefined,
    category: "UNSET",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateGenericPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["moodRef"] = v["moodRef"];
      out["title"] = ctx.decode(TranslatableStringValue.codec, v["title"], "title");
      {
        const ev = ensureScalar(ctx, v["category"], "string") || defaults["category"];
        if (!CategoryValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.point_of_interest.Category`);
        }
        out["category"] = ev as any;
      }
      return out as any as Entity;
    }
  }();
}

export namespace CreateGenericPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_management.CreateGenericPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly genericPointOfInterest: GenericPointOfInterest.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    genericPointOfInterest: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["genericPointOfInterest"] = GenericPointOfInterest.codec.encode(v.genericPointOfInterest);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateGenericPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["genericPointOfInterest"] = ctx.decode(GenericPointOfInterest.codec, v["genericPointOfInterest"], "genericPointOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace CreateMoodRequest {
  export const refName = "mos.org.getty.audio_management.CreateMoodRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    // Relationships
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
    // Attributes
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly imageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly description: TranslatableStringValue.Entity | undefined,
    readonly imageAltText: TranslatableStringValue.Entity | undefined,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly color: MoodColor.Entity | undefined,
    readonly creditText: TranslatableStringValue.Entity | undefined,
    readonly key: string,
  }
  export const defaults: Entity = {
    type: refName,
    siteRef: undefined,
    name: undefined,
    imageRef: undefined,
    description: undefined,
    imageAltText: undefined,
    audio: undefined,
    color: undefined,
    creditText: undefined,
    key: "",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateMoodRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["siteRef"] = v["siteRef"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["imageRef"] = v["imageRef"];
      out["description"] = ctx.decode(TranslatableStringValue.codec, v["description"], "description");
      out["imageAltText"] = ctx.decode(TranslatableStringValue.codec, v["imageAltText"], "imageAltText");
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["color"] = ctx.decode(MoodColor.codec, v["color"], "color");
      out["creditText"] = ctx.decode(TranslatableStringValue.codec, v["creditText"], "creditText");
      out["key"] = ensureScalar(ctx, v["key"], "string");
      return out as any as Entity;
    }
  }();
}

export namespace CreateMoodResponse {
  export const refName = "mos.org.getty.audio_management.CreateMoodResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly mood: Mood.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    mood: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["mood"] = Mood.codec.encode(v.mood);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateMoodResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["mood"] = ctx.decode(Mood.codec, v["mood"], "mood");
      return out as any as Entity;
    }
  }();
}

export namespace CreateStopPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_management.CreateStopPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopRef: { readonly typename: 'mos.org.getty.audio.Stop', readonly id: string } | undefined,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stopRef: undefined,
    moodRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateStopPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopRef"] = v["stopRef"];
      out["moodRef"] = v["moodRef"];
      return out as any as Entity;
    }
  }();
}

export namespace CreateStopPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_management.CreateStopPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopPointOfInterest: StopPointOfInterest.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stopPointOfInterest: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stopPointOfInterest"] = StopPointOfInterest.codec.encode(v.stopPointOfInterest);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateStopPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopPointOfInterest"] = ctx.decode(StopPointOfInterest.codec, v["stopPointOfInterest"], "stopPointOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace CreateStopRequest {
  export const refName = "mos.org.getty.audio_management.CreateStopRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly basedOnRef: { readonly typename: 'mos.org.getty.integration_tms.TMSObject' | 'mos.poi.POI', readonly id: string } | undefined,
    // The Tours that this Stop appears in. Note that even if this list is empty, the
    // Stop will still appear, in Random Access Mode (until or unless we add the ability
    // to have stops _not_ appear in Random Access Mode).
    readonly tourRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Tour', readonly id: string }>,
    // This relationship is not inherently bi-directional - "Stop A" having "Stop B" as a related stop
    // doesn't imply that "Stop B" has "Stop A" as a related stop.
    readonly relatedStopRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
    // Attributes
    readonly wallNumber: string,
    readonly title: TranslatableLinkableStringValue.Entity | undefined,
    readonly image: LinkableMediaValue.Entity | undefined,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly carouselItemRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string }>,
    readonly placement: LinkablePlacementValue.Entity | undefined,
    readonly producedBy: TranslatableLinkableStringValue.Entity | undefined,
    readonly objectDescription: TranslatableLinkableStringValue.Entity | undefined,
    readonly imageAltText: string,
    readonly imageCopyright: LinkableStringValue.Entity | undefined,
    readonly publicImageTitle: TranslatableStringValue.Entity | undefined,
    readonly objectCopyright: LinkableStringValue.Entity | undefined,
    readonly placeCreated: TranslatableLinkableStringValue.Entity | undefined,
    readonly dateCreated: TranslatableLinkableStringValue.Entity | undefined,
    readonly materials: TranslatableLinkableStringValue.Entity | undefined,
    readonly creditLine: TranslatableLinkableStringValue.Entity | undefined,
    readonly artworkName: TranslatableLinkableStringValue.Entity | undefined,
    readonly moodRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Mood', readonly id: string }>,
  }
  export const defaults: Entity = {
    type: refName,
    basedOnRef: undefined,
    tourRefs: [],
    relatedStopRefs: [],
    wallNumber: "",
    title: undefined,
    image: undefined,
    audio: undefined,
    carouselItemRefs: [],
    placement: undefined,
    producedBy: undefined,
    objectDescription: undefined,
    imageAltText: "",
    imageCopyright: undefined,
    publicImageTitle: undefined,
    objectCopyright: undefined,
    placeCreated: undefined,
    dateCreated: undefined,
    materials: undefined,
    creditLine: undefined,
    artworkName: undefined,
    moodRefs: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["basedOnRef"] = v.basedOnRef;
      obj["tourRefs"] = v.tourRefs;
      obj["relatedStopRefs"] = v.relatedStopRefs;
      obj["wallNumber"] = v.wallNumber;
      obj["title"] = TranslatableLinkableStringValue.codec.encode(v.title);
      obj["image"] = LinkableMediaValue.codec.encode(v.image);
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["carouselItemRefs"] = v.carouselItemRefs;
      obj["placement"] = LinkablePlacementValue.codec.encode(v.placement);
      obj["producedBy"] = TranslatableLinkableStringValue.codec.encode(v.producedBy);
      obj["objectDescription"] = TranslatableLinkableStringValue.codec.encode(v.objectDescription);
      obj["imageAltText"] = v.imageAltText;
      obj["imageCopyright"] = LinkableStringValue.codec.encode(v.imageCopyright);
      obj["publicImageTitle"] = TranslatableStringValue.codec.encode(v.publicImageTitle);
      obj["objectCopyright"] = LinkableStringValue.codec.encode(v.objectCopyright);
      obj["placeCreated"] = TranslatableLinkableStringValue.codec.encode(v.placeCreated);
      obj["dateCreated"] = TranslatableLinkableStringValue.codec.encode(v.dateCreated);
      obj["materials"] = TranslatableLinkableStringValue.codec.encode(v.materials);
      obj["creditLine"] = TranslatableLinkableStringValue.codec.encode(v.creditLine);
      obj["artworkName"] = TranslatableLinkableStringValue.codec.encode(v.artworkName);
      obj["moodRefs"] = v.moodRefs;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateStopRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["basedOnRef"] = v["basedOnRef"];
      out["tourRefs"] = v["tourRefs"];
      out["relatedStopRefs"] = v["relatedStopRefs"];
      out["wallNumber"] = ensureScalar(ctx, v["wallNumber"], "string");
      out["title"] = ctx.decode(TranslatableLinkableStringValue.codec, v["title"], "title");
      out["image"] = ctx.decode(LinkableMediaValue.codec, v["image"], "image");
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["carouselItemRefs"] = v["carouselItemRefs"];
      out["placement"] = ctx.decode(LinkablePlacementValue.codec, v["placement"], "placement");
      out["producedBy"] = ctx.decode(TranslatableLinkableStringValue.codec, v["producedBy"], "producedBy");
      out["objectDescription"] = ctx.decode(TranslatableLinkableStringValue.codec, v["objectDescription"], "objectDescription");
      out["imageAltText"] = ensureScalar(ctx, v["imageAltText"], "string");
      out["imageCopyright"] = ctx.decode(LinkableStringValue.codec, v["imageCopyright"], "imageCopyright");
      out["publicImageTitle"] = ctx.decode(TranslatableStringValue.codec, v["publicImageTitle"], "publicImageTitle");
      out["objectCopyright"] = ctx.decode(LinkableStringValue.codec, v["objectCopyright"], "objectCopyright");
      out["placeCreated"] = ctx.decode(TranslatableLinkableStringValue.codec, v["placeCreated"], "placeCreated");
      out["dateCreated"] = ctx.decode(TranslatableLinkableStringValue.codec, v["dateCreated"], "dateCreated");
      out["materials"] = ctx.decode(TranslatableLinkableStringValue.codec, v["materials"], "materials");
      out["creditLine"] = ctx.decode(TranslatableLinkableStringValue.codec, v["creditLine"], "creditLine");
      out["artworkName"] = ctx.decode(TranslatableLinkableStringValue.codec, v["artworkName"], "artworkName");
      out["moodRefs"] = v["moodRefs"];
      return out as any as Entity;
    }
  }();
}

export namespace CreateStopResponse {
  export const refName = "mos.org.getty.audio_management.CreateStopResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stop: Stop.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stop: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stop"] = Stop.codec.encode(v.stop);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateStopResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stop"] = ctx.decode(Stop.codec, v["stop"], "stop");
      return out as any as Entity;
    }
  }();
}

export namespace CreateTourCategoryRequest {
  export const refName = "mos.org.getty.audio_management.CreateTourCategoryRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    // Relationships
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
    readonly tourRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Tour', readonly id: string }>,
    // Attributes
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly supportedLanguages: ReadonlyArray<Language.Entity>,
    readonly siteOrder: number,
  }
  export const defaults: Entity = {
    type: refName,
    siteRef: undefined,
    tourRefs: [],
    name: undefined,
    supportedLanguages: [],
    siteOrder: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateTourCategoryRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["siteRef"] = v["siteRef"];
      out["tourRefs"] = v["tourRefs"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["supportedLanguages"] = decodeMessageRepeated(ctx, Language.codec, v["supportedLanguages"], "supportedLanguages");
      out["siteOrder"] = ensureScalar(ctx, v["siteOrder"], "number");
      return out as any as Entity;
    }
  }();
}

export namespace CreateTourCategoryResponse {
  export const refName = "mos.org.getty.audio_management.CreateTourCategoryResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourCategory: TourCategory.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tourCategory: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tourCategory"] = TourCategory.codec.encode(v.tourCategory);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateTourCategoryResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourCategory"] = ctx.decode(TourCategory.codec, v["tourCategory"], "tourCategory");
      return out as any as Entity;
    }
  }();
}

export namespace CreateTourRequest {
  export const refName = "mos.org.getty.audio_management.CreateTourRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    // Relationships
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
    readonly stopRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
    // Attributes
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly imageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly description: TranslatableStringValue.Entity | undefined,
    readonly durationMinutes: number,
    readonly creditText: TranslatableStringValue.Entity | undefined,
    readonly imageAltText: TranslatableStringValue.Entity | undefined,
    readonly webpageUrl: TranslatableStringValue.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    siteRef: undefined,
    stopRefs: [],
    name: undefined,
    imageRef: undefined,
    description: undefined,
    durationMinutes: 0,
    creditText: undefined,
    imageAltText: undefined,
    webpageUrl: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateTourRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["siteRef"] = v["siteRef"];
      out["stopRefs"] = v["stopRefs"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["imageRef"] = v["imageRef"];
      out["description"] = ctx.decode(TranslatableStringValue.codec, v["description"], "description");
      out["durationMinutes"] = ensureScalar(ctx, v["durationMinutes"], "number");
      out["creditText"] = ctx.decode(TranslatableStringValue.codec, v["creditText"], "creditText");
      out["imageAltText"] = ctx.decode(TranslatableStringValue.codec, v["imageAltText"], "imageAltText");
      out["webpageUrl"] = ctx.decode(TranslatableStringValue.codec, v["webpageUrl"], "webpageUrl");
      return out as any as Entity;
    }
  }();
}

export namespace CreateTourResponse {
  export const refName = "mos.org.getty.audio_management.CreateTourResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tour: Tour.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tour: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tour"] = Tour.codec.encode(v.tour);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateTourResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tour"] = ctx.decode(Tour.codec, v["tour"], "tour");
      return out as any as Entity;
    }
  }();
}

export namespace CreateVisitorTypeRequest {
  export const refName = "mos.org.getty.audio_management.CreateVisitorTypeRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly label: TranslatableStringValue.Entity | undefined,
    readonly tag: string,
  }
  export const defaults: Entity = {
    type: refName,
    label: undefined,
    tag: "",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateVisitorTypeRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["label"] = ctx.decode(TranslatableStringValue.codec, v["label"], "label");
      out["tag"] = ensureScalar(ctx, v["tag"], "string");
      return out as any as Entity;
    }
  }();
}

export namespace CreateVisitorTypeResponse {
  export const refName = "mos.org.getty.audio_management.CreateVisitorTypeResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorType: VisitorType.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorType: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.CreateVisitorTypeResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorType"] = ctx.decode(VisitorType.codec, v["visitorType"], "visitorType");
      return out as any as Entity;
    }
  }();
}

export namespace DeleteCarouselItemRequest {
  export const refName = "mos.org.getty.audio_management.DeleteCarouselItemRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly carouselItemRef: { readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    carouselItemRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteCarouselItemRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["carouselItemRef"] = v["carouselItemRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteCarouselItemResponse {
  export const refName = "mos.org.getty.audio_management.DeleteCarouselItemResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteCarouselItemResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteEventPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_management.DeleteEventPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly eventPointOfInterestRef: { readonly typename: 'mos.org.getty.audio.EventPointOfInterest', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    eventPointOfInterestRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteEventPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["eventPointOfInterestRef"] = v["eventPointOfInterestRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteEventPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_management.DeleteEventPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.EventPointOfInterest', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteEventPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteGenericPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_management.DeleteGenericPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly genericPointOfInterestRef: { readonly typename: 'mos.org.getty.audio.GenericPointOfInterest', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    genericPointOfInterestRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteGenericPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["genericPointOfInterestRef"] = v["genericPointOfInterestRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteGenericPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_management.DeleteGenericPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.GenericPointOfInterest', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteGenericPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteMoodRequest {
  export const refName = "mos.org.getty.audio_management.DeleteMoodRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    moodRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteMoodRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["moodRef"] = v["moodRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteMoodResponse {
  export const refName = "mos.org.getty.audio_management.DeleteMoodResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteMoodResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteStopPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_management.DeleteStopPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopPointOfInterestRef: { readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stopPointOfInterestRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteStopPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopPointOfInterestRef"] = v["stopPointOfInterestRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteStopPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_management.DeleteStopPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteStopPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteStopRequest {
  export const refName = "mos.org.getty.audio_management.DeleteStopRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopRef: { readonly typename: 'mos.org.getty.audio.Stop', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stopRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteStopRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopRef"] = v["stopRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteStopResponse {
  export const refName = "mos.org.getty.audio_management.DeleteStopResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.Stop', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteStopResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteTourCategoryRequest {
  export const refName = "mos.org.getty.audio_management.DeleteTourCategoryRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourCategoryRef: { readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tourCategoryRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteTourCategoryRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourCategoryRef"] = v["tourCategoryRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteTourCategoryResponse {
  export const refName = "mos.org.getty.audio_management.DeleteTourCategoryResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteTourCategoryResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteTourRequest {
  export const refName = "mos.org.getty.audio_management.DeleteTourRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourRef: { readonly typename: 'mos.org.getty.audio.Tour', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tourRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteTourRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourRef"] = v["tourRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteTourResponse {
  export const refName = "mos.org.getty.audio_management.DeleteTourResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.Tour', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteTourResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteVisitorTypeRequest {
  export const refName = "mos.org.getty.audio_management.DeleteVisitorTypeRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorTypeRef: { readonly typename: 'mos.org.getty.audio.VisitorType', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorTypeRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteVisitorTypeRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorTypeRef"] = v["visitorTypeRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeleteVisitorTypeResponse {
  export const refName = "mos.org.getty.audio_management.DeleteVisitorTypeResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.VisitorType', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.DeleteVisitorTypeResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdateAudioSiteContentRequest {
  export const refName = "mos.org.getty.audio_management.UpdateAudioSiteContentRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly audioSiteContentRef: { readonly typename: 'mos.org.getty.audio.AudioSiteContent', readonly id: string } | undefined,
    // The sort order of this field will be used by VX apps for sort order
    readonly tourCategoryRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string }>,
    readonly wayfindingMapRef: { readonly typename: 'mos.org.getty.audio.WayfindingMap', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    audioSiteContentRef: undefined,
    tourCategoryRefs: [],
    wayfindingMapRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateAudioSiteContentRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["audioSiteContentRef"] = v["audioSiteContentRef"];
      out["tourCategoryRefs"] = v["tourCategoryRefs"];
      out["wayfindingMapRef"] = v["wayfindingMapRef"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdateAudioSiteContentResponse {
  export const refName = "mos.org.getty.audio_management.UpdateAudioSiteContentResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly audioSiteContent: AudioSiteContent.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    audioSiteContent: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateAudioSiteContentResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["audioSiteContent"] = ctx.decode(AudioSiteContent.codec, v["audioSiteContent"], "audioSiteContent");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateCarouselItemRequest {
  export type Ref = { readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.audio.CarouselItem');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a UpdateCarouselItemRequest`);
    return v;
  }
  export const refName = "mos.org.getty.audio_management.UpdateCarouselItemRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string } | undefined,
    // NOTE: this is only included for consistency with other Update messages; we
    // only support first-level update paths, so the only valid field in here is
    // 'value'.
    readonly updateMask: FieldMask<"ref" | "value">,
    readonly value: CarouselItemValue.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    value: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["value"] = CarouselItemValue.codec.encode(v.value);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateCarouselItemRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "ref" && fmv !== "value") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["value"] = ctx.decode(CarouselItemValue.codec, v["value"], "value");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateCarouselItemResponse {
  export const refName = "mos.org.getty.audio_management.UpdateCarouselItemResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly carouselItem: CarouselItem.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    carouselItem: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["carouselItem"] = CarouselItem.codec.encode(v.carouselItem);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateCarouselItemResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["carouselItem"] = ctx.decode(CarouselItem.codec, v["carouselItem"], "carouselItem");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateEventPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_management.UpdateEventPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly eventPointOfInterestRef: { readonly typename: 'mos.org.getty.audio.EventPointOfInterest', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"eventPointOfInterestRef" | "audio" | "teaserText" | "content" | "additionalInfo" | "deepDiveLabel" | "deepDiveContextLabel" | "deepDiveUrl" | "placement" | "tags">,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly teaserText: TranslatableStringValue.Entity | undefined,
    readonly content: TranslatableStringValue.Entity | undefined,
    readonly additionalInfo: TranslatableStringValue.Entity | undefined,
    readonly deepDiveLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveContextLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveUrl: TranslatableStringValue.Entity | undefined,
    readonly placement: LinkablePlacementValue.Entity | undefined,
    readonly tags: string,
  }
  export const defaults: Entity = {
    type: refName,
    eventPointOfInterestRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    audio: undefined,
    teaserText: undefined,
    content: undefined,
    additionalInfo: undefined,
    deepDiveLabel: undefined,
    deepDiveContextLabel: undefined,
    deepDiveUrl: undefined,
    placement: undefined,
    tags: "",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["eventPointOfInterestRef"] = v.eventPointOfInterestRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["teaserText"] = TranslatableStringValue.codec.encode(v.teaserText);
      obj["content"] = TranslatableStringValue.codec.encode(v.content);
      obj["additionalInfo"] = TranslatableStringValue.codec.encode(v.additionalInfo);
      obj["deepDiveLabel"] = TranslatableStringValue.codec.encode(v.deepDiveLabel);
      obj["deepDiveContextLabel"] = TranslatableStringValue.codec.encode(v.deepDiveContextLabel);
      obj["deepDiveUrl"] = TranslatableStringValue.codec.encode(v.deepDiveUrl);
      obj["placement"] = LinkablePlacementValue.codec.encode(v.placement);
      obj["tags"] = v.tags;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateEventPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["eventPointOfInterestRef"] = v["eventPointOfInterestRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "eventPointOfInterestRef" && fmv !== "audio" && fmv !== "teaserText" && fmv !== "content" && fmv !== "additionalInfo" && fmv !== "deepDiveLabel" && fmv !== "deepDiveContextLabel" && fmv !== "deepDiveUrl" && fmv !== "placement" && fmv !== "tags") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["teaserText"] = ctx.decode(TranslatableStringValue.codec, v["teaserText"], "teaserText");
      out["content"] = ctx.decode(TranslatableStringValue.codec, v["content"], "content");
      out["additionalInfo"] = ctx.decode(TranslatableStringValue.codec, v["additionalInfo"], "additionalInfo");
      out["deepDiveLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveLabel"], "deepDiveLabel");
      out["deepDiveContextLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveContextLabel"], "deepDiveContextLabel");
      out["deepDiveUrl"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveUrl"], "deepDiveUrl");
      out["placement"] = ctx.decode(LinkablePlacementValue.codec, v["placement"], "placement");
      out["tags"] = ensureScalar(ctx, v["tags"], "string");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateEventPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_management.UpdateEventPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly eventPointOfInterest: EventPointOfInterest.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    eventPointOfInterest: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["eventPointOfInterest"] = EventPointOfInterest.codec.encode(v.eventPointOfInterest);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateEventPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["eventPointOfInterest"] = ctx.decode(EventPointOfInterest.codec, v["eventPointOfInterest"], "eventPointOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateGenericPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_management.UpdateGenericPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly genericPointOfInterestRef: { readonly typename: 'mos.org.getty.audio.GenericPointOfInterest', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"genericPointOfInterestRef" | "audio" | "teaserText" | "content" | "additionalInfo" | "deepDiveLabel" | "deepDiveContextLabel" | "deepDiveUrl" | "placement" | "image" | "title" | "creditText" | "category" | "tags" | "headerText">,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly teaserText: TranslatableStringValue.Entity | undefined,
    readonly content: TranslatableStringValue.Entity | undefined,
    readonly additionalInfo: TranslatableStringValue.Entity | undefined,
    readonly deepDiveLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveContextLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveUrl: TranslatableStringValue.Entity | undefined,
    readonly placement: LinkablePlacementValue.Entity | undefined,
    readonly image: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly title: TranslatableStringValue.Entity | undefined,
    readonly creditText: TranslatableStringValue.Entity | undefined,
    readonly category: Category,
    readonly tags: string,
    readonly headerText: TranslatableStringValue.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    genericPointOfInterestRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    audio: undefined,
    teaserText: undefined,
    content: undefined,
    additionalInfo: undefined,
    deepDiveLabel: undefined,
    deepDiveContextLabel: undefined,
    deepDiveUrl: undefined,
    placement: undefined,
    image: undefined,
    title: undefined,
    creditText: undefined,
    category: "UNSET",
    tags: "",
    headerText: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["genericPointOfInterestRef"] = v.genericPointOfInterestRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["teaserText"] = TranslatableStringValue.codec.encode(v.teaserText);
      obj["content"] = TranslatableStringValue.codec.encode(v.content);
      obj["additionalInfo"] = TranslatableStringValue.codec.encode(v.additionalInfo);
      obj["deepDiveLabel"] = TranslatableStringValue.codec.encode(v.deepDiveLabel);
      obj["deepDiveContextLabel"] = TranslatableStringValue.codec.encode(v.deepDiveContextLabel);
      obj["deepDiveUrl"] = TranslatableStringValue.codec.encode(v.deepDiveUrl);
      obj["placement"] = LinkablePlacementValue.codec.encode(v.placement);
      obj["image"] = v.image;
      obj["title"] = TranslatableStringValue.codec.encode(v.title);
      obj["creditText"] = TranslatableStringValue.codec.encode(v.creditText);
      obj["category"] = v.category;
      obj["tags"] = v.tags;
      obj["headerText"] = TranslatableStringValue.codec.encode(v.headerText);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateGenericPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["genericPointOfInterestRef"] = v["genericPointOfInterestRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "genericPointOfInterestRef" && fmv !== "audio" && fmv !== "teaserText" && fmv !== "content" && fmv !== "additionalInfo" && fmv !== "deepDiveLabel" && fmv !== "deepDiveContextLabel" && fmv !== "deepDiveUrl" && fmv !== "placement" && fmv !== "image" && fmv !== "title" && fmv !== "creditText" && fmv !== "category" && fmv !== "tags" && fmv !== "headerText") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["teaserText"] = ctx.decode(TranslatableStringValue.codec, v["teaserText"], "teaserText");
      out["content"] = ctx.decode(TranslatableStringValue.codec, v["content"], "content");
      out["additionalInfo"] = ctx.decode(TranslatableStringValue.codec, v["additionalInfo"], "additionalInfo");
      out["deepDiveLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveLabel"], "deepDiveLabel");
      out["deepDiveContextLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveContextLabel"], "deepDiveContextLabel");
      out["deepDiveUrl"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveUrl"], "deepDiveUrl");
      out["placement"] = ctx.decode(LinkablePlacementValue.codec, v["placement"], "placement");
      out["image"] = v["image"];
      out["title"] = ctx.decode(TranslatableStringValue.codec, v["title"], "title");
      out["creditText"] = ctx.decode(TranslatableStringValue.codec, v["creditText"], "creditText");
      {
        const ev = ensureScalar(ctx, v["category"], "string") || defaults["category"];
        if (!CategoryValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.point_of_interest.Category`);
        }
        out["category"] = ev as any;
      }
      out["tags"] = ensureScalar(ctx, v["tags"], "string");
      out["headerText"] = ctx.decode(TranslatableStringValue.codec, v["headerText"], "headerText");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateGenericPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_management.UpdateGenericPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly genericPointOfInterest: GenericPointOfInterest.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    genericPointOfInterest: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["genericPointOfInterest"] = GenericPointOfInterest.codec.encode(v.genericPointOfInterest);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateGenericPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["genericPointOfInterest"] = ctx.decode(GenericPointOfInterest.codec, v["genericPointOfInterest"], "genericPointOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateMoodRequest {
  export const refName = "mos.org.getty.audio_management.UpdateMoodRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"moodRef" | "name" | "imageRef" | "description" | "imageAltText" | "audio" | "color" | "creditText" | "key" | "stopPointOfInterestRefs" | "eventPointOfInterestRefs" | "genericPointOfInterestRefs" | "sortedPointOfInterestRefs">,
    // Attributes
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly imageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly description: TranslatableStringValue.Entity | undefined,
    readonly imageAltText: TranslatableStringValue.Entity | undefined,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly color: MoodColor.Entity | undefined,
    readonly creditText: TranslatableStringValue.Entity | undefined,
    readonly key: string,
    readonly stopPointOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string }>,
    readonly eventPointOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.EventPointOfInterest', readonly id: string }>,
    readonly genericPointOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.GenericPointOfInterest', readonly id: string }>,
    readonly sortedPointOfInterestRefs: ReadonlyArray<{ readonly typename: string, readonly id: string }>,
  }
  export const defaults: Entity = {
    type: refName,
    moodRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    name: undefined,
    imageRef: undefined,
    description: undefined,
    imageAltText: undefined,
    audio: undefined,
    color: undefined,
    creditText: undefined,
    key: "",
    stopPointOfInterestRefs: [],
    eventPointOfInterestRefs: [],
    genericPointOfInterestRefs: [],
    sortedPointOfInterestRefs: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["moodRef"] = v.moodRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["name"] = TranslatableStringValue.codec.encode(v.name);
      obj["imageRef"] = v.imageRef;
      obj["description"] = TranslatableStringValue.codec.encode(v.description);
      obj["imageAltText"] = TranslatableStringValue.codec.encode(v.imageAltText);
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["color"] = MoodColor.codec.encode(v.color);
      obj["creditText"] = TranslatableStringValue.codec.encode(v.creditText);
      obj["key"] = v.key;
      obj["stopPointOfInterestRefs"] = v.stopPointOfInterestRefs;
      obj["eventPointOfInterestRefs"] = v.eventPointOfInterestRefs;
      obj["genericPointOfInterestRefs"] = v.genericPointOfInterestRefs;
      obj["sortedPointOfInterestRefs"] = v.sortedPointOfInterestRefs;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateMoodRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["moodRef"] = v["moodRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "moodRef" && fmv !== "name" && fmv !== "imageRef" && fmv !== "description" && fmv !== "imageAltText" && fmv !== "audio" && fmv !== "color" && fmv !== "creditText" && fmv !== "key" && fmv !== "stopPointOfInterestRefs" && fmv !== "eventPointOfInterestRefs" && fmv !== "genericPointOfInterestRefs" && fmv !== "sortedPointOfInterestRefs") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["imageRef"] = v["imageRef"];
      out["description"] = ctx.decode(TranslatableStringValue.codec, v["description"], "description");
      out["imageAltText"] = ctx.decode(TranslatableStringValue.codec, v["imageAltText"], "imageAltText");
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["color"] = ctx.decode(MoodColor.codec, v["color"], "color");
      out["creditText"] = ctx.decode(TranslatableStringValue.codec, v["creditText"], "creditText");
      out["key"] = ensureScalar(ctx, v["key"], "string");
      out["stopPointOfInterestRefs"] = v["stopPointOfInterestRefs"];
      out["eventPointOfInterestRefs"] = v["eventPointOfInterestRefs"];
      out["genericPointOfInterestRefs"] = v["genericPointOfInterestRefs"];
      out["sortedPointOfInterestRefs"] = v["sortedPointOfInterestRefs"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdateMoodResponse {
  export const refName = "mos.org.getty.audio_management.UpdateMoodResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly mood: Mood.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    mood: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["mood"] = Mood.codec.encode(v.mood);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateMoodResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["mood"] = ctx.decode(Mood.codec, v["mood"], "mood");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateStopPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_management.UpdateStopPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopPointOfInterestRef: { readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"stopPointOfInterestRef" | "audio" | "teaserText" | "content" | "additionalInfo" | "deepDiveLabel" | "deepDiveContextLabel" | "deepDiveUrl" | "tags" | "headerText">,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly teaserText: TranslatableStringValue.Entity | undefined,
    readonly content: TranslatableStringValue.Entity | undefined,
    readonly additionalInfo: TranslatableStringValue.Entity | undefined,
    readonly deepDiveLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveContextLabel: TranslatableStringValue.Entity | undefined,
    readonly deepDiveUrl: TranslatableStringValue.Entity | undefined,
    readonly tags: string,
    readonly headerText: TranslatableStringValue.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stopPointOfInterestRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    audio: undefined,
    teaserText: undefined,
    content: undefined,
    additionalInfo: undefined,
    deepDiveLabel: undefined,
    deepDiveContextLabel: undefined,
    deepDiveUrl: undefined,
    tags: "",
    headerText: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stopPointOfInterestRef"] = v.stopPointOfInterestRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["teaserText"] = TranslatableStringValue.codec.encode(v.teaserText);
      obj["content"] = TranslatableStringValue.codec.encode(v.content);
      obj["additionalInfo"] = TranslatableStringValue.codec.encode(v.additionalInfo);
      obj["deepDiveLabel"] = TranslatableStringValue.codec.encode(v.deepDiveLabel);
      obj["deepDiveContextLabel"] = TranslatableStringValue.codec.encode(v.deepDiveContextLabel);
      obj["deepDiveUrl"] = TranslatableStringValue.codec.encode(v.deepDiveUrl);
      obj["tags"] = v.tags;
      obj["headerText"] = TranslatableStringValue.codec.encode(v.headerText);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateStopPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopPointOfInterestRef"] = v["stopPointOfInterestRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "stopPointOfInterestRef" && fmv !== "audio" && fmv !== "teaserText" && fmv !== "content" && fmv !== "additionalInfo" && fmv !== "deepDiveLabel" && fmv !== "deepDiveContextLabel" && fmv !== "deepDiveUrl" && fmv !== "tags" && fmv !== "headerText") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["teaserText"] = ctx.decode(TranslatableStringValue.codec, v["teaserText"], "teaserText");
      out["content"] = ctx.decode(TranslatableStringValue.codec, v["content"], "content");
      out["additionalInfo"] = ctx.decode(TranslatableStringValue.codec, v["additionalInfo"], "additionalInfo");
      out["deepDiveLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveLabel"], "deepDiveLabel");
      out["deepDiveContextLabel"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveContextLabel"], "deepDiveContextLabel");
      out["deepDiveUrl"] = ctx.decode(TranslatableStringValue.codec, v["deepDiveUrl"], "deepDiveUrl");
      out["tags"] = ensureScalar(ctx, v["tags"], "string");
      out["headerText"] = ctx.decode(TranslatableStringValue.codec, v["headerText"], "headerText");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateStopPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_management.UpdateStopPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopPointOfInterest: StopPointOfInterest.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stopPointOfInterest: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stopPointOfInterest"] = StopPointOfInterest.codec.encode(v.stopPointOfInterest);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateStopPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopPointOfInterest"] = ctx.decode(StopPointOfInterest.codec, v["stopPointOfInterest"], "stopPointOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateStopRequest {
  export const refName = "mos.org.getty.audio_management.UpdateStopRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopRef: { readonly typename: 'mos.org.getty.audio.Stop', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"stopRef" | "tourRefs" | "relatedStopRefs" | "wallNumber" | "title" | "image" | "audio" | "carouselItemRefs" | "placement" | "producedBy" | "objectDescription" | "imageAltText" | "imageCopyright" | "publicImageTitle" | "objectCopyright" | "placeCreated" | "dateCreated" | "materials" | "creditLine" | "artworkName" | "moodRefs">,
    // If the stop is added to a tour by updating this field, the stop will be added to the
    // end of the tour's <Tour.stop_refs> attribute.
    readonly tourRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Tour', readonly id: string }>,
    // This relationship is not inherently bi-directional - "Stop A" having "Stop B" as a related stop
    // doesn't imply that "Stop B" has "Stop A" as a related stop.
    readonly relatedStopRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
    // Attributes
    readonly wallNumber: string,
    readonly title: TranslatableLinkableStringValue.Entity | undefined,
    readonly image: LinkableMediaValue.Entity | undefined,
    readonly audio: TranslatableMediaValue.Entity | undefined,
    readonly carouselItemRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string }>,
    readonly placement: LinkablePlacementValue.Entity | undefined,
    readonly producedBy: TranslatableLinkableStringValue.Entity | undefined,
    readonly objectDescription: TranslatableLinkableStringValue.Entity | undefined,
    readonly imageAltText: string,
    readonly imageCopyright: LinkableStringValue.Entity | undefined,
    readonly publicImageTitle: TranslatableStringValue.Entity | undefined,
    readonly objectCopyright: LinkableStringValue.Entity | undefined,
    readonly placeCreated: TranslatableLinkableStringValue.Entity | undefined,
    readonly dateCreated: TranslatableLinkableStringValue.Entity | undefined,
    readonly materials: TranslatableLinkableStringValue.Entity | undefined,
    readonly creditLine: TranslatableLinkableStringValue.Entity | undefined,
    readonly artworkName: TranslatableLinkableStringValue.Entity | undefined,
    readonly moodRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Mood', readonly id: string }>,
  }
  export const defaults: Entity = {
    type: refName,
    stopRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    tourRefs: [],
    relatedStopRefs: [],
    wallNumber: "",
    title: undefined,
    image: undefined,
    audio: undefined,
    carouselItemRefs: [],
    placement: undefined,
    producedBy: undefined,
    objectDescription: undefined,
    imageAltText: "",
    imageCopyright: undefined,
    publicImageTitle: undefined,
    objectCopyright: undefined,
    placeCreated: undefined,
    dateCreated: undefined,
    materials: undefined,
    creditLine: undefined,
    artworkName: undefined,
    moodRefs: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stopRef"] = v.stopRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["tourRefs"] = v.tourRefs;
      obj["relatedStopRefs"] = v.relatedStopRefs;
      obj["wallNumber"] = v.wallNumber;
      obj["title"] = TranslatableLinkableStringValue.codec.encode(v.title);
      obj["image"] = LinkableMediaValue.codec.encode(v.image);
      obj["audio"] = TranslatableMediaValue.codec.encode(v.audio);
      obj["carouselItemRefs"] = v.carouselItemRefs;
      obj["placement"] = LinkablePlacementValue.codec.encode(v.placement);
      obj["producedBy"] = TranslatableLinkableStringValue.codec.encode(v.producedBy);
      obj["objectDescription"] = TranslatableLinkableStringValue.codec.encode(v.objectDescription);
      obj["imageAltText"] = v.imageAltText;
      obj["imageCopyright"] = LinkableStringValue.codec.encode(v.imageCopyright);
      obj["publicImageTitle"] = TranslatableStringValue.codec.encode(v.publicImageTitle);
      obj["objectCopyright"] = LinkableStringValue.codec.encode(v.objectCopyright);
      obj["placeCreated"] = TranslatableLinkableStringValue.codec.encode(v.placeCreated);
      obj["dateCreated"] = TranslatableLinkableStringValue.codec.encode(v.dateCreated);
      obj["materials"] = TranslatableLinkableStringValue.codec.encode(v.materials);
      obj["creditLine"] = TranslatableLinkableStringValue.codec.encode(v.creditLine);
      obj["artworkName"] = TranslatableLinkableStringValue.codec.encode(v.artworkName);
      obj["moodRefs"] = v.moodRefs;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateStopRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopRef"] = v["stopRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "stopRef" && fmv !== "tourRefs" && fmv !== "relatedStopRefs" && fmv !== "wallNumber" && fmv !== "title" && fmv !== "image" && fmv !== "audio" && fmv !== "carouselItemRefs" && fmv !== "placement" && fmv !== "producedBy" && fmv !== "objectDescription" && fmv !== "imageAltText" && fmv !== "imageCopyright" && fmv !== "publicImageTitle" && fmv !== "objectCopyright" && fmv !== "placeCreated" && fmv !== "dateCreated" && fmv !== "materials" && fmv !== "creditLine" && fmv !== "artworkName" && fmv !== "moodRefs") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["tourRefs"] = v["tourRefs"];
      out["relatedStopRefs"] = v["relatedStopRefs"];
      out["wallNumber"] = ensureScalar(ctx, v["wallNumber"], "string");
      out["title"] = ctx.decode(TranslatableLinkableStringValue.codec, v["title"], "title");
      out["image"] = ctx.decode(LinkableMediaValue.codec, v["image"], "image");
      out["audio"] = ctx.decode(TranslatableMediaValue.codec, v["audio"], "audio");
      out["carouselItemRefs"] = v["carouselItemRefs"];
      out["placement"] = ctx.decode(LinkablePlacementValue.codec, v["placement"], "placement");
      out["producedBy"] = ctx.decode(TranslatableLinkableStringValue.codec, v["producedBy"], "producedBy");
      out["objectDescription"] = ctx.decode(TranslatableLinkableStringValue.codec, v["objectDescription"], "objectDescription");
      out["imageAltText"] = ensureScalar(ctx, v["imageAltText"], "string");
      out["imageCopyright"] = ctx.decode(LinkableStringValue.codec, v["imageCopyright"], "imageCopyright");
      out["publicImageTitle"] = ctx.decode(TranslatableStringValue.codec, v["publicImageTitle"], "publicImageTitle");
      out["objectCopyright"] = ctx.decode(LinkableStringValue.codec, v["objectCopyright"], "objectCopyright");
      out["placeCreated"] = ctx.decode(TranslatableLinkableStringValue.codec, v["placeCreated"], "placeCreated");
      out["dateCreated"] = ctx.decode(TranslatableLinkableStringValue.codec, v["dateCreated"], "dateCreated");
      out["materials"] = ctx.decode(TranslatableLinkableStringValue.codec, v["materials"], "materials");
      out["creditLine"] = ctx.decode(TranslatableLinkableStringValue.codec, v["creditLine"], "creditLine");
      out["artworkName"] = ctx.decode(TranslatableLinkableStringValue.codec, v["artworkName"], "artworkName");
      out["moodRefs"] = v["moodRefs"];
      return out as any as Entity;
    }
  }();
}

export namespace UpdateStopResponse {
  export const refName = "mos.org.getty.audio_management.UpdateStopResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stop: Stop.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stop: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stop"] = Stop.codec.encode(v.stop);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateStopResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stop"] = ctx.decode(Stop.codec, v["stop"], "stop");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateTourCategoriesRequest {
  export const refName = "mos.org.getty.audio_management.UpdateTourCategoriesRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourCategoryUpdates: ReadonlyArray<UpdateTourCategoryRequest.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    tourCategoryUpdates: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tourCategoryUpdates"] = [];
      for (const item of v.tourCategoryUpdates) {
        obj["tourCategoryUpdates"].push(UpdateTourCategoryRequest.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateTourCategoriesRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourCategoryUpdates"] = decodeMessageRepeated(ctx, UpdateTourCategoryRequest.codec, v["tourCategoryUpdates"], "tourCategoryUpdates");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateTourCategoriesResponse {
  export const refName = "mos.org.getty.audio_management.UpdateTourCategoriesResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourCategories: ReadonlyArray<TourCategory.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    tourCategories: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tourCategories"] = [];
      for (const item of v.tourCategories) {
        obj["tourCategories"].push(TourCategory.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateTourCategoriesResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourCategories"] = decodeMessageRepeated(ctx, TourCategory.codec, v["tourCategories"], "tourCategories");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateTourCategoryRequest {
  export const refName = "mos.org.getty.audio_management.UpdateTourCategoryRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourCategoryRef: { readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"tourCategoryRef" | "tourRefs" | "name" | "supportedLanguages" | "siteOrder">,
    // Relationships
    readonly tourRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Tour', readonly id: string }>,
    // Attributes
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly supportedLanguages: ReadonlyArray<Language.Entity>,
    readonly siteOrder: number,
  }
  export const defaults: Entity = {
    type: refName,
    tourCategoryRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    tourRefs: [],
    name: undefined,
    supportedLanguages: [],
    siteOrder: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tourCategoryRef"] = v.tourCategoryRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["tourRefs"] = v.tourRefs;
      obj["name"] = TranslatableStringValue.codec.encode(v.name);
      obj["supportedLanguages"] = [];
      for (const item of v.supportedLanguages) {
        obj["supportedLanguages"].push(Language.codec.encode(item));
      }
      obj["siteOrder"] = v.siteOrder;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateTourCategoryRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourCategoryRef"] = v["tourCategoryRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "tourCategoryRef" && fmv !== "tourRefs" && fmv !== "name" && fmv !== "supportedLanguages" && fmv !== "siteOrder") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["tourRefs"] = v["tourRefs"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["supportedLanguages"] = decodeMessageRepeated(ctx, Language.codec, v["supportedLanguages"], "supportedLanguages");
      out["siteOrder"] = ensureScalar(ctx, v["siteOrder"], "number");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateTourCategoryResponse {
  export const refName = "mos.org.getty.audio_management.UpdateTourCategoryResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourCategory: TourCategory.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tourCategory: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tourCategory"] = TourCategory.codec.encode(v.tourCategory);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateTourCategoryResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourCategory"] = ctx.decode(TourCategory.codec, v["tourCategory"], "tourCategory");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateTourRequest {
  export const refName = "mos.org.getty.audio_management.UpdateTourRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourRef: { readonly typename: 'mos.org.getty.audio.Tour', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"tourRef" | "stopRefs" | "name" | "imageRef" | "description" | "durationMinutes" | "creditText" | "imageAltText" | "webpageUrl">,
    readonly stopRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
    // Attributes
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly imageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly description: TranslatableStringValue.Entity | undefined,
    readonly durationMinutes: number,
    readonly creditText: TranslatableStringValue.Entity | undefined,
    readonly imageAltText: TranslatableStringValue.Entity | undefined,
    readonly webpageUrl: TranslatableStringValue.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tourRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    stopRefs: [],
    name: undefined,
    imageRef: undefined,
    description: undefined,
    durationMinutes: 0,
    creditText: undefined,
    imageAltText: undefined,
    webpageUrl: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tourRef"] = v.tourRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["stopRefs"] = v.stopRefs;
      obj["name"] = TranslatableStringValue.codec.encode(v.name);
      obj["imageRef"] = v.imageRef;
      obj["description"] = TranslatableStringValue.codec.encode(v.description);
      obj["durationMinutes"] = v.durationMinutes;
      obj["creditText"] = TranslatableStringValue.codec.encode(v.creditText);
      obj["imageAltText"] = TranslatableStringValue.codec.encode(v.imageAltText);
      obj["webpageUrl"] = TranslatableStringValue.codec.encode(v.webpageUrl);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateTourRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourRef"] = v["tourRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "tourRef" && fmv !== "stopRefs" && fmv !== "name" && fmv !== "imageRef" && fmv !== "description" && fmv !== "durationMinutes" && fmv !== "creditText" && fmv !== "imageAltText" && fmv !== "webpageUrl") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["stopRefs"] = v["stopRefs"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["imageRef"] = v["imageRef"];
      out["description"] = ctx.decode(TranslatableStringValue.codec, v["description"], "description");
      out["durationMinutes"] = ensureScalar(ctx, v["durationMinutes"], "number");
      out["creditText"] = ctx.decode(TranslatableStringValue.codec, v["creditText"], "creditText");
      out["imageAltText"] = ctx.decode(TranslatableStringValue.codec, v["imageAltText"], "imageAltText");
      out["webpageUrl"] = ctx.decode(TranslatableStringValue.codec, v["webpageUrl"], "webpageUrl");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateTourResponse {
  export const refName = "mos.org.getty.audio_management.UpdateTourResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tour: Tour.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tour: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tour"] = Tour.codec.encode(v.tour);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateTourResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tour"] = ctx.decode(Tour.codec, v["tour"], "tour");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateVisitorTypeRequest {
  export const refName = "mos.org.getty.audio_management.UpdateVisitorTypeRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorTypeRef: { readonly typename: 'mos.org.getty.audio.VisitorType', readonly id: string } | undefined,
    readonly updateMask: FieldMask<"visitorTypeRef" | "label" | "tag">,
    // Attributes
    readonly label: TranslatableStringValue.Entity | undefined,
    readonly tag: string,
  }
  export const defaults: Entity = {
    type: refName,
    visitorTypeRef: undefined,
    updateMask: { type: "google.protobuf.FieldMask", fields: [] },
    label: undefined,
    tag: "",
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["visitorTypeRef"] = v.visitorTypeRef;
      obj["updateMask"] = v.updateMask.fields.join(",");
      obj["label"] = TranslatableStringValue.codec.encode(v.label);
      obj["tag"] = v.tag;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateVisitorTypeRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorTypeRef"] = v["visitorTypeRef"];
      {
        const fmvs = ensureScalar(ctx, v["updateMask"], "string").split(/\s,\s/);
        for (const fmv of fmvs) {
          if (fmv !== "visitorTypeRef" && fmv !== "label" && fmv !== "tag") {
            throw ctx.error(`received invalid value ${fmv} in field mask`);
          }
        }
        out["updateMask"] = fmvs;
      }
      out["label"] = ctx.decode(TranslatableStringValue.codec, v["label"], "label");
      out["tag"] = ensureScalar(ctx, v["tag"], "string");
      return out as any as Entity;
    }
  }();
}

export namespace UpdateVisitorTypeResponse {
  export const refName = "mos.org.getty.audio_management.UpdateVisitorTypeResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorType: VisitorType.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorType: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_management.UpdateVisitorTypeResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorType"] = ctx.decode(VisitorType.codec, v["visitorType"], "visitorType");
      return out as any as Entity;
    }
  }();
}

